import { createStyles } from '@material-ui/core';

const styles = (theme) => {
  return createStyles({
    baseButtonContainer: {
      position: 'relative',
      borderRadius: 12,
      padding: '8px 16px',
      gap: 8,
      textDecoration: 'none',
      border: '2px solid transparent',
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 104,
      '&:hover': {
        opacity: 0.9,
      },
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
    },
    brand: {
      backgroundColor: theme.palette.primary.main,
      backgroundImage: `linear-gradient(${theme.palette.primary.main}, ${theme.palette.primary.main}), linear-gradient(0deg, rgba(0,0,0,0.20) 0%, rgba(255,255,255,0.20) 100%)`,
    },
    brandText: {
      color: 'white',
    },
    primary: {
      backgroundColor: theme.palette.grey[50],
      backgroundImage: `linear-gradient(${theme.palette.grey[50]}, ${theme.palette.grey[50]}), linear-gradient(0deg, ${theme.palette.grey[900]}20 30%, ${theme.palette.grey[50]}20 100%)`,
    },
    primaryText: {
      color: theme.palette.grey[900],
    },
    secondary: {
      backgroundColor: theme.palette.grey[900],
      backgroundImage: `linear-gradient(${theme.palette.grey[900]}, ${theme.palette.grey[900]}), linear-gradient(0deg, ${theme.palette.grey[50]}20 30%, ${theme.palette.grey[900]}20 100%)`,
    },
    secondaryText: {
      color: theme.palette.grey[50],
    },
    outlined: {
      backgroundColor: 'transparent',
      border: `1px solid ${theme.palette.grey[100]}`,
    },
    outlinedText: {
      color: theme.palette.grey[900],
    },
    destroyGhost: {
      backgroundColor: 'transparent',
    },
    destroyGhostText: {
      color: theme.palette.error.main,
    },
    destroy: {
      backgroundColor: theme.palette.error.main,
      backgroundImage: `linear-gradient(${theme.palette.error.main}, ${theme.palette.error.main}), linear-gradient(0deg, rgba(0,0,0,0.20) 0%, rgba(255,255,255,0.20) 100%)`,
    },
    destroyText: {
      color: 'white',
    },
    transparent: {
      backgroundColor: `${theme.palette.grey[100]}30`,
    },
    transparentText: {
      color: theme.palette.grey[900],
    },
    text: {
      padding: 0,
      backgroundColor: 'transparent',
    },
    textText: {
      color: theme.palette.grey[900],
    },
    link: {
      backgroundColor: 'transparent',
      padding: 0,
    },
    linkText: {
      color: theme.palette.primary.main,
    },
    disabled: {
      opacity: 0.5,
      cursor: 'default',
      pointerEvents: 'none',
      '&:hover': {
        opacity: 0.5,
      },
    },
    small: {
      height: 36,
      padding: '8px',
    },
    medium: {
      height: 40,
      padding: '12px 16px',
    },
    large: {
      height: 48,
      padding: '8px 16px',
    },
    alwaysFullWidth: {
      width: '100%',
    },
    desktopFullWidth: {
      [theme.breakpoints.up('md')]: {
        width: '100%',
      },
    },
    mobileFullWidth: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    noneFullWidth: {
      width: 'fit-content',
    },
    labelHidden: {
      visibility: 'hidden',
    },
    circularProgress: {
      position: 'absolute',
      margin: 'auto',
    },
    icon: {
      height: 24,
    },
  });
};

export default styles;
